import React from 'react';
import cx from 'classnames';

import styles from './Card.module.scss';
import { ICardProps } from './Card.type';

const Card = ({ title, children, className }: ICardProps) => {
	return (
		<div className={cx(styles.card, className)}>
			{title && (
				<div className={styles.cardHeader}>
					<div className={styles.cardTitle}>{title}</div>
				</div>
			)}
			<div className={styles.cardBody}>{children}</div>
		</div>
	);
};

export default Card;
